import { ReactElement, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import usePermissions from 'hooks/usePermissions';
import { hasAnyAdminAccess } from 'utils/adminAccess';

// ==============================|| ADMIN GUARD ||============================== //

/**
 * Route guard for Admin (Companies/Sites/Devices/Peripherals) pages. Redirects away unless the
 * user holds at least one of the relevant permissions — either any Admin permission (the
 * default), or the specific `requiredPermissions` passed in for a narrower sub-route.
 */
export default function AdminGuard({ children, requiredPermissions }: { children: ReactElement | null; requiredPermissions?: string[] }) {
  const { hasPermission, loading } = usePermissions();
  const navigate = useNavigate();

  const authorized = requiredPermissions ? requiredPermissions.some((code) => hasPermission(code)) : hasAnyAdminAccess(hasPermission);

  useEffect(() => {
    if (loading) return;
    if (!authorized) navigate('/pages/access-denied', { replace: true });
  }, [loading, authorized, navigate]);

  if (loading || !authorized) return null;

  return children;
}
